<template>
  <div class="monthly-weather">
    <el-dialog title="" :visible.sync="params.flag" v-dialogDrag :modal="false" :close-on-click-modal="false"
      :lock-scroll="false" :modal-append-to-body="false" ref="mwRef" :before-close="() => params.flag && $parent.toggleProductView(params.productInfo.code)
        ">
      <div slot="title" class="select-header">
        <span>每月天气</span>
        <span>数据来源:实况来源格点实况，预报来源于EC模式32天预报</span>
      </div>
      <div class="content-box">
        <div class="c-header">
          <div class="left">{{ year }}年{{ month }}月</div>
          <div class="right">
            <el-button-group>
              <el-button size="mini" class="btn" @click="changeMonth(-1)" :disabled="disabled">上个月</el-button>
              <el-button size="mini" class="btn" @click="changeMonth()">当月</el-button>
              <el-button size="mini" class="btn" @click="changeMonth(+1)">下个月</el-button>
            </el-button-group>
          </div>
        </div>
        <div class="calender-box">
          <div class="week-box">
            <div class="week" v-for="item in weeks" :key="item">{{ item }}</div>
          </div>
          <div class="calender-day-box">
            <div class="calender-day-item calender-day-bu" v-for="item in Number(week)" :key="item + 'b'"></div>
            <div class="calender-day-item" v-for="(date, index) in calenDay" :key="index">
              <div :key="item.ddate" v-for="(item, index) in calenderData">
                <div v-if="forestTime(date) !== 'default' && date == item.ddate" :class="{
                  'day-box': true,
                  forest: true,
                  'sevet-time': forestTime(date) == 'seven',
                  'forest-time': forestTime(date) == 'forest',
                  'current-day': date.split('-')[2] == new Date().getDate(),
                }">
                  <div class="time">
                    <span>{{ date.split("-")[2] }}</span>
                    <span :class="{ 'jie-ri': solarToLunar(date).includes('节') }">{{ solarToLunar(date) }}</span>
                  </div>
                  <div class="info">
                    <div class="icon" v-if="item.icons">
                      <img :src="require(
                        `../assets/images/weatherIcon_p/${item.icons}.png`,
                      )
                        " alt="" />
                      <div>{{ item.desc }}</div>
                    </div>
                    <div class="temp1">
                      <span>{{ item.maxt }}/{{ item.mint }}°C</span>
                    </div>
                  </div>
                </div>

                <div v-else-if="
                  date == item.ddate && forestTime(date) == 'default'
                " class="day-box" style="z-index: 99; background: #fff">
                  <div class="time">
                    <span>{{ date.split("-")[2] }}</span>
                    <span>{{ solarToLunar(date) }}</span>
                  </div>
                  <div class="info">
                    <div class="temp">
                      <span>{{ item.maxt }}</span><span>/{{ item.mint }}℃</span>
                    </div>
                    <div class="rain">
                      <img src="@/assets/images/雨伞.png" alt="" />
                      <span>{{ item.rain === 9999.9 ? "--" : item.rain }}mm</span>
                    </div>
                  </div>
                </div>

                <div v-else-if="index == 0 && forestTime(date) == 'default'" class="day-box">
                  <div class="time">
                    <span>{{ date.split("-")[2] }}</span>
                    <span>{{ solarToLunar(date) }}</span>
                  </div>
                  <div class="info no-content">暂无数据</div>
                </div>
              </div>
            </div>
            <div class="calender-day-item calender-day-bu" v-for="item in week1" :key="item + 'c'"></div>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import calendar from "@/utils/calendar.js";
import { apiData } from "../api/index";
import { mapState } from "vuex";

export default {
  props: ["params"],
  data() {
    return {
      currentDay: new Date(),
      calenderData: [],
      forestData: [],
      giftData: [],
      weeks: ["日", "一", "二", "三", "四", "五", "六"],
      year: new Date().getFullYear(),
      month: new Date().getMonth() + 1,
      day: new Date().getDate(),
      num: 0,
      week: 0,
      week1: 0,
      calenDay: [],
      disabled: false,
    };
  },
  watch: {
    "params.flag": {
      handler(flag) {
        flag && this.setZindex();
      },
      immediate: true,
    },
    activeCountyId: {
      handler() {
        this.getMrtqData();
      },
      immediate: true,
    },
  },
  computed: {
    ...mapState("home", ["activeCountyId", "objsList", "sevenDayDataResult"]),
  },
  mounted() {
    this.getGiftData();
    this.getMrtqData();
    this.num = new Date(Number(this.year), Number(this.month), 0).getDate();
    this.calenDay = [];
    for (let i = 0; i < this.num; i++) {
      const day = (i + 1 + "").padStart(2, "0");
      const date =
        this.year + "-" + (this.month + "").padStart(2, "0") + "-" + day;
      this.calenDay.push(date);
    }
    this.week = new Date(this.year + "-" + this.month + "-01").getDay();
    this.week1 =
      6 - new Date(this.year + "-" + this.month + "-" + this.num).getDay();
  },

  methods: {
    changeMonth(type) {
      if (type === -1 && this.month === 1) {
        if (this.year === new Date().getFullYear()) {
          this.disabled = true;
          return " ";
        }
        this.year = this.year - 1;
        this.month = 12;
      } else if (type === +1 && this.month === 12) {
        this.year = this.year + 1;
        this.month = 1;
      } else if (!type) {
        this.month = new Date().getMonth() + 1;
      } else {
        this.month = this.month + type;
      }
      this.disabled = false;
      this.num = new Date(Number(this.year), Number(this.month), 0).getDate();
      this.calenDay = [];
      for (let i = 0; i < this.num; i++) {
        const day = (i + 1 + "").padStart(2, "0");
        const date =
          this.year + "-" + (this.month + "").padStart(2, "0") + "-" + day;
        this.calenDay.push(date);
      }
      this.week = new Date(this.year + "-" + this.month + "-01").getDay();
      this.week1 =
        6 - new Date(this.year + "-" + this.month + "-" + this.num).getDay();
    },
    equalDay(day) {
      const y = new Date().getFullYear();
      const m = new Date().getMonth() + 1;
      const d = new Date().getDate();

      if ((y === this.year) & (m === this.month) & (d === day)) {
        return true;
      } else {
      }
    },
    async getMrtqData() {
      const result = await apiData.getMrtqData(this.activeCountyId);
      const item = this.objsList.find(
        (item) => item.id === this.activeCountyId,
      );
      const lon = (Math.round(item.lon / 0.5) * 0.5)
        .toFixed(2)
        .replace(/\./g, "");
      const lat = (Math.round(item.lat / 0.5) * 0.5)
        .toFixed(2)
        .replace(/\./g, "");
      const result1 = await apiData.getecDaily(lon, lat);
      const day = this.$moment(new Date()).format("YYYY/MM/DD");
      const currentSecond = new Date(day).getTime();
      const lastData = result.data.filter((item) => {
        return new Date(item.ddate).getTime() < currentSecond;
      });

      const y = new Date().getFullYear();
      const index = result1.datedec.findIndex((item) => {
        const day = y + "/" + item.slice(0, 2) + "/" + item.slice(3, 5);
        return new Date(day).getTime() === currentSecond;
      });
      this.forestData = [];
      result1.datedec.slice(10).forEach((item, index1) => {
        if (index1 >= index) {
          const obj = {
            ddate: y + "-" + item.slice(0, 2) + "-" + item.slice(3, 5),
            maxt: result1.maxt[index1],
            mint: result1.mint[index1],
            desc: result1.desc[index1],
            icons: parseInt(result1.icons[index1]).toString(),
          };
          this.forestData.push(obj);
        }
      });

      this.calenderData = [...lastData, ...this.giftData, ...this.forestData];
      console.log("this.calenderData", this.calenderData);
    },
    // 获取gif预报 获取当地地区的未来十日天气结论数据 替代EC模式的预报前10天
    async getGiftData() {
      try {
        const result = JSON.parse(JSON.stringify(this.sevenDayDataResult));
        if (!result) {
          return;
        }
        // console.log('当前选中点位', this.activeCountyId)
        // 根据点位所在区获取对应的位置预报
        const index = this.objsList.findIndex(
          (item) => item.id === this.activeCountyId,
        );
        const county = this.objsList[index].county.replace("区", "");
        console.log("this.objsList", this.objsList);
        console.log("county", county);
        const countyResult = result.data[county] || {};

        const day = this.$moment(new Date()).format("YYYY/MM/DD");
        const currentSecond = new Date(day).getTime();
        const y = new Date().getFullYear();
        const indexDate = countyResult.date.findIndex((item) => {
          const day = y + "/" + item.slice(0, 2) + "/" + item.slice(3, 5);
          return new Date(day).getTime() === currentSecond;
        });
        this.giftData = [];
        countyResult.date.forEach((item, index1) => {
          if (index1 >= indexDate) {
            const obj = {
              ddate: y + "-" + item.slice(0, 2) + "-" + item.slice(3, 5),
              maxt: countyResult.maxt[index1],
              mint: countyResult.mint[index1],
              desc: countyResult.desc[index1],
              icons: parseInt(countyResult.icon[index1]).toString(),
            };
            this.giftData.push(obj);
          }
        });
        console.log("this.giftData", this.giftData);
      } catch (e) {
        console.error(e);
      }
    },
    // 计算是否是未来10天的日期
    forestTime(date) {
      const valTime = new Date(date).getTime();
      const nowTime = new Date().getTime();
      const sevenTime = nowTime + 86400000 * 10;
      const forsetTime = nowTime + 86400000 * (this.forestData.length - 1);
      if (nowTime < valTime && valTime < sevenTime) {
        return "seven";
      } else if (nowTime < valTime && valTime < forsetTime) {
        return "forest";
      } else {
        return "default";
      }
    },

    // 公历转农历
    solarToLunar(slotData) {
      const solarDayArr = slotData.split("-");
      const lunarDay = calendar.solar2lunar(
        solarDayArr[0],
        solarDayArr[1],
        solarDayArr[2],
      );
      // 农历日期
      const lunarMD = lunarDay.IDayCn;
      // 公历节日\农历节日\农历节气
      let festAndTerm = [];
      festAndTerm.push(
        lunarDay.festival == null ? "" : " " + lunarDay.festival,
      );
      festAndTerm.push(
        lunarDay.lunarFestival == null ? "" : "" + lunarDay.lunarFestival,
      );
      festAndTerm.push(lunarDay.Term == null ? "" : "" + lunarDay.Term);
      festAndTerm = festAndTerm.join("");
      return festAndTerm === "" ? lunarMD : festAndTerm;
    },

    // 设置弹出框的zIndex
    setZindex() {
      this.$nextTick(() => {
        const el = this.$refs.mwRef;
        let zIndex = JSON.parse(localStorage.getItem("dialogZIndex"));
        zIndex = zIndex * 1 + 1;
        el.$el.style.zIndex = zIndex;
        localStorage.setItem("dialogZIndex", JSON.stringify(zIndex));
      });
    },
  },
};
</script>

<style lang="less" scoped>
.monthly-weather {
  pointer-events: none;

  .select-header {
    display: flex;
    justify-content: space-between;
    padding-right: 2.6vw;
    color: #fff;

    span:nth-child(1) {
      font-size: 0.94vw;
      font-weight: 600;
      color: #fff;
    }

    span:nth-child(2) {
      font-size: 0.73vw;
    }
  }

  .content-box {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;

    .c-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      color: #fff;
      margin: 0.5vw 0px;

      .el-button {
        margin: 0;
        background: #3c7cb8;
        border: 1px solid #5592cb;
        color: #fff;
      }

      /deep/ .el-button:focus,
      .el-button:hover {
        background: linear-gradient(33deg, #5e97ff 0%, #7ab2ff 100%);
      }
    }

    .calender-box {
      display: flex;
      flex-direction: column;
      flex: 1;
      box-sizing: border-box;
      padding: 0vw 1.56vw;
      background: #3c7cb8;
      overflow: hidden;
      overflow-y: auto;

      .week-box {
        display: flex;
        justify-content: space-between;
        height: 3.18vw;
        background: #3c7cb8;

        .week {
          width: calc((100% - 60px) / 7);
          text-align: center;
          font-size: 0.83vw;
          font-weight: 400;
          line-height: 3.18vw;
          color: #fff;
        }
      }

      .calender-day-box {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
        flex: 1;
        overflow: hidden;
        overflow-y: auto;
      }

      .calender-day-item {
        position: relative;
        width: calc((100% - 3.13vw) / 7);
        height: 9.25vw;
        margin-bottom: 0.52vw;
        background: #3e67ca;
        border-radius: 0.31vw;
      }

      .calender-day-bu {
        background: transparent;
      }

      .day-box {
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: absolute;
        height: 100%;
        width: 100%;
        box-sizing: border-box;
        padding: 0.42vw;
        font-size: 0.94vw;
        text-align: right;
        border: 0;
        border-radius: 0.31vw;
        color: #fff;
        background: #647db7 !important;

        .time {
          display: flex;
          justify-content: space-between;
          color: #f7f1f1;

          span:nth-child(1) {
            color: #fff;
            font-size: 1.25vw;
          }
        }

        .info {
          display: flex;
          flex-direction: column;
          justify-content: flex-end;
          align-items: flex-end;
          flex: 1;

          .temp {
            margin-bottom: 0.52vw;

            span:nth-child(1) {
              font-size: 1.15vw;
            }
          }

          .rain {
            img {
              width: 0.73vw;
              margin-right: 0.42vw;
            }
          }

          .text {
            margin: 0.52vw 0vw;
          }
        }

        .no-content {
          justify-content: center;
          align-items: center;
        }
      }

      .forest-time {
        .info {
          .icon {
            color: #fff;
          }

          .temp1 {
            span {
              color: #fff;
            }
          }
        }
      }

      .sevet-time {
        color: white;
        font-size: 0.94vw;
        background: linear-gradient(207deg,
            #8bb1f6 0%,
            #4c89f6 100%) !important;

        .time {
          span:nth-child(1) {
            color: #fff;
          }
        }

        .info {
          .temp1 {
            span {
              color: #fff !important;
            }
          }
        }
      }

      .sevet-time.current-day {
        border: 1px solid #006cff;
      }

      .forest {
        font-size: 0.94vw;
        border-radius: 6px;

        .info {
          display: flex;
          flex-direction: column;
          align-items: center;
          text-align: center;

          .icon {
            img {
              width: 2.45vw;
            }
          }

          .temp1 {
            font-size: 0.94vw !important;
            margin: 0.52vw 0vw;
          }
        }
      }

      .jie-ri {
        width: 3.28vw;
        height: 1.3vw;
        text-align: center;
        font-size: 0.83vw;
        font-weight: 400;
        color: #ff921a;
        line-height: 1.3vw;
        border-radius: 0.31vw;
        border: 0.05vw solid #ff921a;
        background: rgba(255, 146, 26, 0.04);
      }
    }
  }

  /deep/ .el-dialog__wrapper {
    overflow: hidden;

    .el-dialog {
      width: 55.75vw;
      height: 88vh;
      // width: 200vw;
      // height: 100vh;
      margin-top: 2vh !important;
      pointer-events: auto;

      .el-dialog__body {
        overflow: hidden;
      }
    }
  }

  ::-webkit-scrollbar {
    width: 0.2vw;
  }

  ::-webkit-scrollbar-track {
    background: #1f2c49;
    border-radius: 1.09vw;
  }

  ::-webkit-scrollbar-thumb {
    background: #42506e;
    border-radius: 1.09vw;
    height: 1.56vw;
  }
}
</style>
